import React from 'react';

import EditPanelHeading from '../EditPanelHeading';

import './AnimationOptionMenu.css';

interface Props {
  title?: string;
  children: React.ReactNode;
  variant?: 'dark' | 'light';
}

const AnimationOptionMenu = React.forwardRef<HTMLDivElement, Props>(({ title, children, variant = 'dark' }, ref) => {
  const menuClassName = `AnimationOptionMenu AnimationOptionMenu--${variant}`;
  return (
    <div className={menuClassName} id="animation-options-menu" ref={ref}>
      <EditPanelHeading>{title}</EditPanelHeading>
      <div>{children}</div>
    </div>
  );
});

export default AnimationOptionMenu;
